module.exports = __webpack_public_path__ + "static/media/COS_YSONUT.78284960.jpg";